import { HAS_FILE_READER } from '@eventbrite/eds-utils';

/**
 * Asynchronously load an entire image into memory as a dataUri.
 * The result can be used as an Img src to display the image in-page.
 */
export const loadImageFileDataURL = (file) => {
    if (!HAS_FILE_READER) {
        throw new Error(
            'Unable to loadImageFileDataURL in environment without FileReader',
        );
    }

    return new Promise((resolve, reject) => {
        const reader = new window.FileReader();

        reader.onloadend = () => resolve(reader.result);

        try {
            reader.readAsDataURL(file);
        } catch (er) {
            reject();
        }
    });
};
